import { IStore } from '../../../common/store';

const carConfigurationSelectors = {
  getLoadingState: (state: IStore) => state.customiseCombinedReducer.carConfigurationReducer.loading,
  getSelectedAccessories: (state: IStore) =>
    state.customiseCombinedReducer.carConfigurationReducer.customisedCar?.accessories,
  getSelectedAccessoryPacks: (state: IStore) =>
    state.customiseCombinedReducer.carConfigurationReducer.customisedCar?.packs,
  getConfiguration: (state: IStore) => state.customiseCombinedReducer.carConfigurationReducer.configuration,
  getConfigurationModelTitle: (state: IStore) =>
    state.customiseCombinedReducer.carConfigurationReducer.configuration?.model.title,
  getConfigurationTitle: (state: IStore) => state.customiseCombinedReducer.carConfigurationReducer.configuration?.title,
  getConfigurationImages: (state: IStore) =>
    state.customiseCombinedReducer.carConfigurationReducer.configuration?.images,
  getCustomisedCar: (state: IStore) => state.customiseCombinedReducer.carConfigurationReducer.customisedCar,
  getDisclaimers: (state: IStore) => state.customiseCombinedReducer.carConfigurationReducer?.configuration?.disclaimers,
  getSelectedServicePlan: (state: IStore) =>
    state.customiseCombinedReducer.carConfigurationReducer?.customisedCar?.servicePlan,
  getConfigurationPrices: (state: IStore) =>
    state.customiseCombinedReducer.carConfigurationReducer.configuration?.prices,
  getSelectedVariant: (state: IStore) =>
    state.customiseCombinedReducer.carConfigurationReducer?.customisedCar?.variantId,
  getConfigurationCategory: (state: IStore) =>
    state.customiseCombinedReducer.carConfigurationReducer.customisedCar?.marketingCategory,
  getSelectedExteriorColour: (state: IStore) =>
    state.customiseCombinedReducer.carConfigurationReducer?.customisedCar?.exterior,
  getSelectedInterior: (state: IStore) =>
    state.customiseCombinedReducer.carConfigurationReducer?.customisedCar?.interior?.id,
  getIsInteriorImageDisplay: (state: IStore) =>
    state.customiseCombinedReducer.carConfigurationReducer?.customisedCar?.shouldDisplayInterior,
  getConfigurationKeyFeatures: (state: IStore) =>
    state.customiseCombinedReducer.carConfigurationReducer?.configuration?.keyFeatures,
  getConfigurationEngineTitle: (state: IStore) =>
    state.customiseCombinedReducer.carConfigurationReducer?.configuration?.engine?.title,
  getConfigurationTransmissionTitle: (state: IStore) =>
    state.customiseCombinedReducer.carConfigurationReducer?.configuration?.gearbox?.title,
  getConfigurationStock: (state: IStore) =>
    state.customiseCombinedReducer.carConfigurationReducer?.configuration?.stock,
};

export default carConfigurationSelectors;
